export enum AuroraModel {
  AURORA_28 = 'Aurora 28',
  AURORA_50 = 'Aurora 50',
  AURORA_64 = 'Aurora 64',
  AURORA_FROST = 'Aurora Frost'
}
